module.exports = __webpack_public_path__ + "fonts/ab9ad2af5173386ca57e8d4b2aa56c7d.svg";